import { Injectable } from '@angular/core';

import { buildInfo as generatedBuildInfo } from '../../../generated/build-info';

export interface BuildInfo {
  hash: string;
  branch: string;
  date: string;
  buildNumber: string;
  version: string;
}

@Injectable({
  providedIn: 'root',
})
export class BuildInfoService {
  private readonly buildInfo: BuildInfo = generatedBuildInfo;

  getBuildInfo(): BuildInfo {
    return this.buildInfo;
  }

  getVersion(): string {
    return this.buildInfo.version;
  }

  getGitHash(): string {
    return this.buildInfo.hash;
  }

  getBuildNumber(): string {
    return this.buildInfo.buildNumber;
  }

  getBranch(): string {
    return this.buildInfo.branch;
  }

  getBuildDate(): string {
    return this.buildInfo.date;
  }

  getFormattedBuildInfo(): string {
    // eslint-disable-next-line
    return `Build ${this.buildInfo.version} (${this.buildInfo.branch}) - ${new Date(this.buildInfo.date).toLocaleString()}`;
  }

  logBuildInfo(): void {
    /* eslint-disable no-console */
    console.group('🔧 Build Information');
    console.log('Version:', this.buildInfo.version);
    console.log('Git Hash:', this.buildInfo.hash);
    console.log('Branch:', this.buildInfo.branch);
    console.log('Build Number:', this.buildInfo.buildNumber);
    console.log('Build Date:', new Date(this.buildInfo.date).toLocaleString());
    console.groupEnd();
    /* eslint-enable no-console */
  }
}
